import React from 'react';
import LazyImage from '../shared/LazyImage';
import Link from 'next/link';
import parser from 'html-react-parser';
export function NewsCardHorizontal({
  src,
  title,
  content,
  tag,
  link,
  sub_link,
}: {
  src?: string | null;
  title?: string | null;
  content?: string | null;
  tag?: string | null;
  link?: string | null;
  sub_link?: string | null;
}) {
  return (
    <div className="flex border-b py-4 md:flex-row">
      <Link href={link || ''}>
        <div className="relative h-[53px] w-[94px] md:h-[130px] md:min-w-[226px]">
          <LazyImage
            alt={'thumnail'}
            fill
            className="object-fit"
            src={src || ''}
            sizes="10vw"
            priority={true}
          />
        </div>
      </Link>

      <div className="flex flex-col gap-2 px-3 md:p-3">
        <Link href={sub_link || ''}>
          <p className="text-caption-medium">{tag}</p>
        </Link>
        <Link href={link || ''}>
          <p className="text-h5 hover:text-primary-eastern md:py-1">{title}</p>
        </Link>
        <Link href={link || ''}>
          <p className="text-body-regular line-clamp-4">
            {content && parser(content)}
          </p>
        </Link>
      </div>
    </div>
  );
}
